var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.icon)?_c('img',{staticClass:"base-icon",class:_vm.customClass,attrs:{"src":_vm.setIcon(require('@/assets/icons/' + _vm.icon + '.svg')),"alt":""},on:{"click":_vm.onClick}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }